module.exports = __webpack_public_path__ + "static/img/25.a19fdba.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/25.png
// module id = iuIv
// module chunks = 1